<template>
  <Head>
    <Meta charset="utf-8" />
    <Meta name="viewport" content="width=device-width, initial-scale=1" />
    <Link rel="preconnect" href="https://fonts.googleapis.com" />
    <Link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
    <Link
      href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
      rel="stylesheet"
    />
    <Link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
    <Link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <Link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    <Link rel="manifest" href="/site.webmanifest" />
    <Link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
    <Meta name="msapplication-TileColor" content="#da532c" />
    <Meta name="theme-color" content="#ffffff" />
  </Head>

  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import AOS from 'aos'
import useMq from '@/composables/useMq'
// Preload the above-the-fold heading weights (Medium=hero h1/blockquote,
// Semibold=section headings). Regular + MediumItalic are below-the-fold.
// ?url resolves to the same hashed /_nuxt asset the CSS @font-face emits.
import erodeMediumUrl from '@/static/fonts/Erode-Medium.woff2?url'
import erodeSemiboldUrl from '@/static/fonts/Erode-Semibold.woff2?url'

const { SITE_URL } = useRuntimeConfig()
const route = useRoute()

// Self-referencing canonical, absolute from the per-contour SITE_URL, query
// stripped and trailing slash normalised away (root stays "/"). Set once here
// so every route — static and /blog/[slug] — gets a correct canonical and a
// matching og:url, instead of the previous site-wide og:url = homepage and no
// canonical at all (recon 2026-07-20 s5.3). Pages may still override og:image.
const canonicalUrl = computed(() => {
  const path = route.path.replace(/\/+$/, '')
  return `${SITE_URL}${path || '/'}`
})

useServerSeoMeta({
  ogImage: `${SITE_URL}/images/og-image.png`,
  ogImageSecureUrl: `${SITE_URL}/images/og-image.png`,
  ogImageWidth: '1200',
  ogImageHeight: '630',
  ogImageAlt: 'Medical Licensing promo img',
  ogImageType: 'image/png',
  ogLocale: 'en_US',
  ogSiteName: 'Credsy',
  ogType: 'website',
  ogUrl: () => canonicalUrl.value,
  twitterImage: `${SITE_URL}/images/og-image.png`,
  twitterImageAlt: 'Medical Licensing promo img',
  twitterCard: 'summary_large_image',
})

useHead({
  htmlAttrs: {
    lang: 'en',
  },
  bodyAttrs: {
    class: 'bg-white',
  },
  link: [
    { rel: 'canonical', href: () => canonicalUrl.value },
    { rel: 'preload', as: 'font', type: 'font/woff2', href: erodeMediumUrl, crossorigin: 'anonymous' },
    { rel: 'preload', as: 'font', type: 'font/woff2', href: erodeSemiboldUrl, crossorigin: 'anonymous' },
  ],
  meta: [{ charset: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }],
})

useSchemaOrg([
  defineWebSite({}),
  defineWebPage({}),
  defineOrganization({
    name: 'Medicallicensing',
    logo: `/images/logo.mark.png`,
  }),
])

const {
  screen,
  isPhone,
  isShortTablet,
  isWideTablet,
  isTablet,
  isDesktop,
  isPhoneOrTablet,
  isTabletOrDesktop,
  isXs,
  isSm,
  isMd,
  isAir,
  isLg,
  isXl,
  is2Xl,
} = useMq()

provide('screen', screen)
provide('isPhone', isPhone)
provide('isShortTablet', isShortTablet)
provide('isWideTablet', isWideTablet)
provide('isTablet', isTablet)
provide('isDesktop', isDesktop)
provide('isPhoneOrTablet', isPhoneOrTablet)
provide('isTabletOrDesktop', isTabletOrDesktop)
provide('isXs', isXs)
provide('isSm', isSm)
provide('isMd', isMd)
provide('isAir', isAir)
provide('isLg', isLg)
provide('isXl', isXl)
provide('is2Xl', is2Xl)

onMounted(() => {
  AOS.init()
})
</script>
